import { FC, useState } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import { MapMarker } from '@/components/Map/MapMarker';
import envVariables from '@/envVariables';
import { Map } from './Map';

type MapWrapperProps = {
  coordinates: {
    deviceLocation: { lng: number; lat: number; label: string };
    venueLocation?: { lng: number; lat: number; label: string };
  };
};

export const MapWrapper: FC<MapWrapperProps> = ({ coordinates }) => {
  const currentZoom = 14;
  const centerPosition = {
    lat: coordinates.deviceLocation.lat,
    lng: coordinates.deviceLocation.lng,
  };
  const [mapRef, setMapRef] = useState();
  const [geocoder, setGeocoder] = useState<google.maps.Geocoder>();
  const markerDevicePosition = {
    lat: coordinates.deviceLocation.lat,
    lng: coordinates.deviceLocation.lng,
  };
  const markerVenuePosition = coordinates?.venueLocation && {
    lat: coordinates.venueLocation.lat,
    lng: coordinates.venueLocation.lng,
  };
  const [map, setMap] = useState<google.maps.Map>();

  if (mapRef && !map) {
    setMap(
      new google.maps.Map(mapRef, {
        zoom: currentZoom,
        center: {
          lat: coordinates.deviceLocation.lat,
          lng: coordinates.deviceLocation.lng,
        },
        zoomControl: true,
        gestureHandling: 'cooperative',
      }),
    );
  }

  if (map && !geocoder) {
    setGeocoder(new google.maps.Geocoder());
  }

  return (
    <Wrapper
      apiKey={envVariables.googleMapsKey}
      libraries={['places']}
      region='GB'
      language='en-GB'
    >
      <Map
        center={centerPosition}
        map={map}
        setMapRef={setMapRef}
        zoom={currentZoom}
      >
        {markerDevicePosition && (
          <MapMarker
            position={markerDevicePosition}
            label={coordinates.deviceLocation.label}
          />
        )}
        {markerVenuePosition && (
          <MapMarker
            position={markerVenuePosition}
            label={coordinates.venueLocation?.label}
          />
        )}
      </Map>
    </Wrapper>
  );
};
